import React, { useState } from 'react';
import './signInForm.css';
// import { useGoogleOAuth } from '../../hooks/authentication/useGoogleOAuth';

const SignInForm = ({ formState, handleChange, handleSubmit, error, userType, onGoogleSignInSuccess }) =>{
    const profileType  = userType === 'profesionales' ? 'trabajadores' : 'empresas'
    const [showPassword, setShowPassword] = useState(false);
    
    // Use the Google OAuth hook
    // const { googleButtonRef } = useGoogleOAuth(userType, onGoogleSignInSuccess, 'signin_with');

    return (
      <form className="sign-in__auth-form" onSubmit={handleSubmit}>
        <h2>Entra a tu cuenta {profileType}</h2>
        <div className="sign-in__input-container">
          <label>Email</label>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formState.email}
            onChange={handleChange}
            className="sign-in-form__input"
          />
        </div>
        <div className="sign-in__input-container">
          <label>Contraseña</label>
          <div className="password-input-container">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Contraseña"
              className="sign-in-form__input"
              value={formState.password}
              onChange={handleChange}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
        </div>
        <input type="submit" className="sign-in__button" value="Entrar" />
        {error && <p className="error-message">{error}</p>}
        
        {/* Google Sign-In Button at the bottom */}
        {/* <div className="google-signin-container">
          <div ref={googleButtonRef}></div>
        </div> */}
      </form>
    );};

export default SignInForm;
